import { apiClient } from '@/shared/api/client';
import type {
  Candidate,
  CreateCandidateRequest,
  UpdateCandidateRequest,
  UpdateCandidateStatusRequest,
  UpdateCandidateConsentRequest,
  ListCandidatesParams,
} from '../types/candidate.types';
import type { ApiResponse } from '@/shared/types/api.types';

async function get<T>(endpoint: string): Promise<T> {
  const response = await apiClient<ApiResponse<T>>(endpoint, { method: 'GET' });
  return response.data;
}

async function post<T>(endpoint: string, body?: unknown): Promise<T> {
  const response = await apiClient<ApiResponse<T>>(endpoint, { method: 'POST', body });
  return response.data;
}

async function put<T>(endpoint: string, body: unknown): Promise<T> {
  const response = await apiClient<ApiResponse<T>>(endpoint, { method: 'PUT', body });
  return response.data;
}

async function patch<T>(endpoint: string, body: unknown): Promise<T> {
  const response = await apiClient<ApiResponse<T>>(endpoint, { method: 'PATCH', body });
  return response.data;
}

async function del<T>(endpoint: string): Promise<T> {
  const response = await apiClient<ApiResponse<T>>(endpoint, { method: 'DELETE' });
  return response.data;
}

function buildCandidateListQuery(params: ListCandidatesParams): string {
  return new URLSearchParams({ companyId: params.companyId }).toString();
}

export const candidateService = {
  listCandidates: (params: ListCandidatesParams): Promise<Candidate[]> =>
    get(`/candidates?${buildCandidateListQuery(params)}`),

  getCandidateById: (id: string): Promise<Candidate> => get(`/candidates/${id}`),

  createCandidate: (data: CreateCandidateRequest): Promise<Candidate> => post('/candidates', data),

  updateCandidate: (id: string, data: UpdateCandidateRequest): Promise<Candidate> =>
    put(`/candidates/${id}`, data),

  deleteCandidate: (id: string): Promise<Candidate> => del(`/candidates/${id}`),

  updateCandidateStatus: (id: string, data: UpdateCandidateStatusRequest): Promise<Candidate> =>
    patch(`/candidates/${id}/status`, data),

  updateCandidateConsent: (id: string, data: UpdateCandidateConsentRequest): Promise<Candidate> =>
    patch(`/candidates/${id}/consent`, data),

  resendInvitation: (id: string): Promise<Candidate> => post(`/candidates/${id}/resend-invitation`),
};
